export function initAccordions($trigger, $parent, $body) {
	$trigger.on('click', function (event) {
		event.preventDefault();
		
		var $this = $(this);

		$this.closest($parent).find($body).first().stop().slideToggle();

		$this.closest($parent).toggleClass('opened');
	});
}


// WEBPACK FOOTER //
// ../src/assets/js/accordions.js